import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

import EventDetailsContent from './EventDetailsContent.jsx';

const CalendarEventModal = ({ showModal, event, close }) => (
  <Modal className="inmodal" show={showModal} onHide={close} backdrop >
    <Modal.Header closeButton>
      <Modal.Title>{event.EVENT_NAME}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <EventDetailsContent event={event} calendar />
    </Modal.Body>
  </Modal>
);

CalendarEventModal.propTypes = {
  close: PropTypes.func.isRequired,
  event: PropTypes.object.isRequired,
  showModal: PropTypes.bool.isRequired
};

export default CalendarEventModal;



// WEBPACK FOOTER //
// ./src/components/eventDetails/CalendarEventModal.jsx